import { hasPermission } from './Permissions';

const MASTER_DATA_PREFIX = 'master_data.';
const CORPORATE_PREFIX = 'corporate_structure.';

const ACTION_ALIASES = {
    create: ['add'],
    delete: ['activate'],
    import: ['add'],
};

function hasExactPermission(name) {
    return hasPermission(name);
}

function permissionAliases(permission, prefix, aliases) {
    if (!permission.startsWith(prefix)) {
        return [];
    }

    const rest = permission.slice(prefix.length);
    const dot = rest.indexOf('.');

    if (dot === -1) {
        return [];
    }

    const module = rest.slice(0, dot);
    const action = rest.slice(dot + 1);
    const names = [];

    for (const [canonical, legacyActions] of Object.entries(aliases)) {
        if (legacyActions.includes(action)) {
            names.push(`${prefix}${module}.${canonical}`);
        }

        if (action === canonical) {
            legacyActions.forEach((legacy) => {
                names.push(`${prefix}${module}.${legacy}`);
            });
        }
    }

    return names.filter((name) => name !== permission);
}

export function hasMasterDataPermission(permission) {
    if (hasExactPermission(permission)) {
        return true;
    }

    return permissionAliases(permission, MASTER_DATA_PREFIX, ACTION_ALIASES)
        .some((alias) => hasExactPermission(alias));
}

export function hasCorporateStructurePermission(permission) {
    if (hasExactPermission(permission)) {
        return true;
    }

    return permissionAliases(permission, CORPORATE_PREFIX, ACTION_ALIASES)
        .some((alias) => hasExactPermission(alias));
}

export function hasAnyMasterDataMenuAccess() {
    const modules = [
        'departments', 'positions', 'locations', 'offices', 'companies', 'emitters',
        'policy_types', 'product_types', 'tax_regime', 'advisor_commission_tiers',
    ];

    return modules.some((module) => hasMasterDataPermission(`master_data.${module}.view`));
}

export function hasAnyCorporateStructureMenuAccess() {
    const modules = ['prospects', 'employees', 'advisers', 'directory', 'org_chart'];

    return modules.some((module) => hasCorporateStructurePermission(`corporate_structure.${module}.view`));
}
